<template>
    <div>
        <slot />
        <template v-for="(action, i) in actions">
            <action-menu v-if="action.type === 'menu'" :key="'menu-' + i">
                <v-list>
                    <v-list-item
                        v-for="(menuAction, i) in action.actions"
                        :key="'menu' + menuAction.type + i"
                        link
                        @click="$emit('click', menuAction)"
                        :disabled="menuAction.disabled"
                    >
                        <v-list-item-title>
                            {{ menuAction.label }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </action-menu>

            <action-button
                v-else-if="action.type == 'show' && pageContext !== 'show'"
                icon="mdi-eye"
                :key="'show-' + i"
                :label="$t('resources.actions.show')"
                :to="action.to"
            />

            <edit-button
                v-else-if="action.type == 'edit' && pageContext !== 'edit'"
                :key="'edit-' + i"
                :to="action.to"
            />

            <delete-button
                v-else-if="action.type == 'delete'"
                :key="'delete-' + i"
                :disabled="action.disabled"
                @click="$emit('click', action)"
            />

            <restore-button
                v-else-if="action.type == 'restore'"
                :key="'restore-' + i"
                :disabled="action.disabled"
                @click="$emit('click', action)"
            />

            <action-button
                v-else-if="
                    !['menu', 'show', 'edit', 'delete'].includes(action.type)
                "
                :icon="action.icon || 'mdi-play'"
                :color="action.color"
                :key="action.type + i"
                :label="action.label"
                :to="action.to"
                :disabled="action.disabled"
                @click="$emit('click', action)"
            />
        </template>
    </div>
</template>

<script>
import ActionButton from './ActionButton'
import ActionMenu from './ActionMenu'
import EditButton from './EditButton'
import DeleteButton from './DeleteButton'
import RestoreButton from './RestoreButton'

export default {
    components: {
        ActionButton,
        ActionMenu,
        EditButton,
        DeleteButton,
        RestoreButton,
    },

    props: {
        model: {
            type: Object,
            required: true,
        },
        pageContext: {
            type: String,
            required: true,
        },
    },

    data() {
        return { actions: [] }
    },

    methods: {
        filter(action) {
            if (action.type === 'menu') {
                action.actions = action.actions.filter(this.filter)
                if (action.actions.length == 0) return false
            }

            if (action.permission) {
                let hasPermission = this.can(action.permission)
                if (!hasPermission) return false
            }

            return !action.hide
        },
    },

    created() {
        this.actions = this.model.actions.filter(this.filter)
    },
}
</script>

<style></style>
